import { DialogTitle as NovaBaseDialogTitle, DialogTitleProps } from '@fme-nova/components'
import { DialogTitle as MuiBaseDialogTitle, styled } from '@mui/material'

import { createComponentWrapperWithRef } from '../../theme'
import { COLORS } from '../../theme/colors'

const MuiDialogTitle = styled(MuiBaseDialogTitle)<DialogTitleProps>`
  background-color: ${COLORS.grey50};
  padding: 16px 24px;
`

export const DialogTitle = createComponentWrapperWithRef<DialogTitleProps>(
  {
    mui: MuiDialogTitle,
    nova: NovaBaseDialogTitle,
  },
  'DialogTitle',
)
